import { IconButton, Stack, TooltipHost, useTheme } from '@fluentui/react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ApprovalLevelViewData,
  ApprovalLevelViewRowValues,
  ApprovalValues,
} from '../../../types';

import { useReactFlow } from '@xyflow/react';
import { ApprovalSetupFlowCommonData } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/ApprovalSetupFlowCommonData';
import { convertToApprovalLevelNodes } from '../../ApproverLevels/utils';
import { setNodeScrollState } from '../../Conditions';
import { FormView } from '../AddLevelNode/FormView';

export const UpdateTree: React.FC<{
  approvalTypes: ApprovalSetupFlowCommonData | undefined;
  data: ApprovalLevelViewData;
}> = ({ data }) => {
  const { setNodes, setEdges } = useReactFlow();
  const formMethods = useFormContext<ApprovalValues>();
  const [visibility, setVisibility] = useState(false);
  const theme = useTheme();

  const handleUpdateCondition = (formFields: any) => {
    // @ts-ignore
    formMethods.setValue(
      // @ts-ignore
      `approvalTrees.${data.levelIndex}`,
      {
        ...data,
        ...formFields,
      },
      { shouldDirty: true }
    );

    const { nodes: modulatedNodes, edges: modulatedEdges } =
      convertToApprovalLevelNodes(
        // @ts-ignore
        formMethods.getValues('approvalTrees'),
        'vertical'
      );
    setNodes([...modulatedNodes]);
    setEdges([...modulatedEdges]);
    setNodeScrollState(true);
    setVisibility(false);
  };

  return (
    <Stack>
      <TooltipHost content={'Edit'}>
        <IconButton
          styles={{
            icon: { fontSize: 16, color: 'white' },
            iconHovered: {
              color: 'white',
            },
            rootHovered: { backgroundColor: theme.palette.themeDarkAlt },
            root: { height: 20, width: 20 },
          }}
          iconProps={{ iconName: 'PageHeaderEdit' }}
          onClick={() => {
            setNodeScrollState(false);
            setVisibility(true);
          }}
        />
      </TooltipHost>

      <FormView
        data={data}
        onSave={handleUpdateCondition}
        onClose={() => {
          setNodeScrollState(true);
          setVisibility(false);
        }}
        visibility={visibility}
      />
    </Stack>
  );
};
